import { Link } from "react-router-dom";
import { CloudSlash, ArrowRight } from "@phosphor-icons/react";

export default function DriveRequired({ title = "Нужен доступ к Google Drive", description }) {
  return (
    <div
      className="bg-white border border-[#18181b] hard-shadow p-8 flex flex-col sm:flex-row items-start gap-6"
      data-testid="drive-required"
    >
      <div className="shrink-0 border border-[#18181b] p-4 bg-[#f5f5f4]">
        <CloudSlash size={28} weight="duotone" className="text-[#0047FF]" />
      </div>
      <div className="min-w-0 flex-1">
        <h2 className="text-lg font-medium tracking-tight">{title}</h2>
        <p className="text-sm text-[#52525b] mt-2 max-w-xl">
          {description ||
            "Этот раздел работает с файлами на Google Drive. Подключите Drive один раз — приложение запомнит доступ и будет работать автономно."}
        </p>
        <Link
          to="/connect"
          data-testid="drive-required-connect"
          className="mt-5 inline-flex items-center gap-2 bg-[#0047FF] text-white px-4 py-2 text-sm hover:bg-[#0036CC] transition-colors duration-150"
        >
          Подключить Drive
          <ArrowRight size={14} weight="bold" />
        </Link>
      </div>
    </div>
  );
}
